
    import "./src/embed.tsx";
    // @ts-ignore
    window.SalonBookingWidget.mount("#root", {
      apiBase: (window.__BOONA_API_BASE__ ?? import.meta.env.VITE_API_URL ?? "https://boona.app"),
      companyId: 88612
    });
  